import { createUseStyles } from 'react-jss'

import { lightGrey, mediumGrey } from '../../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../../styles/const/common'
import { phonesDown } from '../../../../styles/const/breakpoints'

export default createUseStyles({
  tabItem: {
    backgroundColor: isActive => (isActive ? 'white' : 'transparent'),
    padding: '3px 8px',
    transition: transitionShort,
    border: isActive => (isActive ? `1px solid ${mediumGrey}` : '1px solid transparent'),
    borderRadius: defaultBorderRadius,
    cursor: 'pointer',
    '&:not(:last-child)': {
      marginRight: '10px'
    },

    '&:hover': {
      border: isActive => (isActive ? `1px solid ${mediumGrey}` : `1px solid ${lightGrey}`)
    }
  },
  [`@media screen and (${phonesDown})`]: {
    tabItem: {
      '&:not(:last-child)': {
        marginRight: '5px'
      }
    }
  }
})
